var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdgeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_",
    "data-name": "!",
    d: "M10,0A10,10,0,1,0,20,10,9.994,9.994,0,0,0,10,0Zm1.027,13.97c0,.316-.461.632-1.027.632-.592,0-1.014-.316-1.014-.632V8.954c0-.369.421-.619,1.014-.619.566,0,1.027.25,1.027.619ZM10,7.125a1.03,1.03,0,0,1-1.079-.948A1.02,1.02,0,0,1,10,5.242a1.016,1.016,0,0,1,1.066.935A1.026,1.026,0,0,1,10,7.125Z",
    fill: "#f84457"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdgeIcon);
export default __webpack_public_path__ + "static/media/edgeIcon.514589c3a9df2b1ee8d435b32493d330.svg";
export { ForwardRef as ReactComponent };